/**
 * @generated SignedSource<<c33ba5a4a5ffef3cc92544c4955d1952>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditPageQuery$variables = {
  id: string;
};
export type RoomEditPageQuery$data = {
  readonly room: {
    readonly hotel: {
      readonly id: string;
      readonly name: string;
    };
    readonly nameString: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"RoomEditTabs_room" | "RoomSidebar_room">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditTabs_data">;
};
export type RoomEditPageQuery = {
  response: RoomEditPageQuery$data;
  variables: RoomEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameString",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Hotel",
  "kind": "LinkedField",
  "name": "hotel",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v7 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "etgKey",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Room",
        "kind": "LinkedField",
        "name": "room",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomEditTabs_room"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomSidebar_room"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RoomEditTabs_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoomEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Room",
        "kind": "LinkedField",
        "name": "room",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "media(first:2147483647)"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capacity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomProperty",
            "kind": "LinkedField",
            "name": "properties",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TextTranslationConnection",
                "kind": "LinkedField",
                "name": "translations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextTranslationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TextTranslation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "string",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Text",
            "kind": "LinkedField",
            "name": "descriptionText",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TextBlockConnection",
                "kind": "LinkedField",
                "name": "blocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextBlockEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TextBlock",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "data",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Language",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readOnly",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "RoomPropertyConnection",
        "kind": "LinkedField",
        "name": "roomProperties",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoomPropertyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoomProperty",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "roomProperties(first:2147483647)"
      }
    ]
  },
  "params": {
    "cacheID": "55b7841932f6d223e7d8eb8653d0ad3a",
    "id": null,
    "metadata": {},
    "name": "RoomEditPageQuery",
    "operationKind": "query",
    "text": "query RoomEditPageQuery(\n  $id: ID!\n) {\n  room(id: $id) {\n    nameString\n    hotel {\n      id\n      name\n    }\n    ...RoomEditTabs_room\n    ...RoomSidebar_room\n    id\n  }\n  ...RoomEditTabs_data\n}\n\nfragment EditorJsField_data on Query {\n  languages {\n    locale\n    ...EditorLanguageField_language\n    ...EditorToolbar_languages\n  }\n}\n\nfragment EditorJsField_text on Text {\n  id\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n  ...EditorToolbar_text\n}\n\nfragment EditorLanguageButton_language on Language {\n  name\n  locale\n  ...LanguageIndicator_language\n}\n\nfragment EditorLanguageButton_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment EditorLanguageField_language on Language {\n  locale\n  readOnly\n}\n\nfragment EditorToolbar_languages on Language {\n  locale\n  ...EditorLanguageButton_language\n  ...EditorTranslateButton_to\n  ...EditorTranslateButton_from\n}\n\nfragment EditorToolbar_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        ...EditorTranslateButton_textBlock\n        id\n      }\n    }\n  }\n  ...EditorLanguageButton_text\n}\n\nfragment EditorTranslateButton_from on Language {\n  locale\n}\n\nfragment EditorTranslateButton_textBlock on TextBlock {\n  id\n  data\n}\n\nfragment EditorTranslateButton_to on Language {\n  locale\n  readOnly\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment LanguageIndicator_language on Language {\n  locale\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment RoomEditMainGeneral_data on Query {\n  ...RoomPropertySelect_data\n  ...TranslatableTextField_data\n}\n\nfragment RoomEditMainGeneral_room on Room {\n  name {\n    ...TranslatableTextField_text\n    id\n  }\n}\n\nfragment RoomEditMain_data on Query {\n  ...EditorJsField_data\n  ...RoomEditMainGeneral_data\n  ...useTranslatableField_data\n  ...useEditorJsField_data\n}\n\nfragment RoomEditMain_room on Room {\n  id\n  capacity\n  description\n  properties {\n    id\n    name\n    icon\n    etgKey\n  }\n  name {\n    ...useTranslatableField_text\n    id\n  }\n  descriptionText {\n    ...EditorJsField_text\n    ...useEditorJsField_text\n    id\n  }\n  ...RoomEditMainGeneral_room\n}\n\nfragment RoomEditTabs_data on Query {\n  ...RoomEditMain_data\n}\n\nfragment RoomEditTabs_room on Room {\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  ...RoomEditMain_room\n  ...MediaEditor_mediable\n}\n\nfragment RoomPropertySelect_data on Query {\n  roomProperties(first: 2147483647) {\n    edges {\n      node {\n        id\n        name\n        icon\n        etgKey\n      }\n    }\n  }\n}\n\nfragment RoomSidebar_room on Room {\n  ...EntitySidebar_entity\n}\n\nfragment TranslatableTextFieldInput_data on Query {\n  languages {\n    locale\n    ...TranslatableTextFieldTranslateButton_from\n  }\n}\n\nfragment TranslatableTextFieldInput_language on Language {\n  locale\n  readOnly\n  ...LanguageIndicator_language\n  ...TranslatableTextFieldTranslateButton_to\n}\n\nfragment TranslatableTextFieldInput_text on Text {\n  translations {\n    edges {\n      node {\n        locale\n        ...TranslatableTextFieldTranslateButton_textTranslation\n        id\n      }\n    }\n  }\n}\n\nfragment TranslatableTextFieldTranslateButton_from on Language {\n  locale\n  ...LanguageIndicator_language\n}\n\nfragment TranslatableTextFieldTranslateButton_textTranslation on TextTranslation {\n  id\n  string\n}\n\nfragment TranslatableTextFieldTranslateButton_to on Language {\n  locale\n  readOnly\n}\n\nfragment TranslatableTextField_data on Query {\n  languages {\n    locale\n    ...TranslatableTextFieldInput_language\n  }\n  ...TranslatableTextFieldInput_data\n}\n\nfragment TranslatableTextField_text on Text {\n  ...TranslatableTextFieldInput_text\n}\n\nfragment useEditorJsField_data on Query {\n  languages {\n    locale\n  }\n}\n\nfragment useEditorJsField_text on Text {\n  blocks {\n    edges {\n      node {\n        locale\n        data\n        id\n      }\n    }\n  }\n}\n\nfragment useTranslatableField_data on Query {\n  languages {\n    locale\n  }\n}\n\nfragment useTranslatableField_text on Text {\n  translations {\n    edges {\n      node {\n        locale\n        string\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b01a24c944261f0207ad005d1b680ced";

export default node;
